<template>
  <div class="content-panel">
    <a-card :bordered="false">
      <a-input-search
        v-model="searchValue"
        style="margin-bottom: 8px"
        placeholder="支持对组织机构名称的模糊查询"
        @search="queryDeptData"
      />
      <a-button type="primary" v-action:add_dept @click="createOrg()" block>新增组织机构</a-button>

      <a-tree
        :treeData="treeData"
        :draggable="$auth('baseInfo.drag_dept')"
        @expand="onExpand"
        :expandedKeys="expandedKeys"
        @dragstart="onStart"
        @drop="showConfirm"
        @select="select"
        :defaultSelectedKeys="defaultSelectedKeys"
      >
        <template slot="custom" slot-scope="item">
          <span>{{ item.name }}</span>
          <div class="icon-panel">
            <a-tooltip v-if="$auth('baseInfo.add_dept')">
              <template slot="title">
                新建
              </template>
              <a-icon type="plus" @click="() => createOrg(item)" />
            </a-tooltip>
            <a-tooltip v-action:edit_dept>
              <template slot="title">
                编辑
              </template>
              <a-icon type="edit" @click="() => editOrg(item)" />
            </a-tooltip>
            <a-popconfirm
              placement="topRight"
              v-action:delete_dept
              :title="'您确定要删除' + item.name + '吗?'"
              @confirm="e => deleteOrg(item.id)"
            >
              <a-tooltip>
                <template slot="title">
                  删除
                </template>
                <a-icon type="delete" />
              </a-tooltip>
            </a-popconfirm>
          </div>
        </template>
      </a-tree>
    </a-card>

    <edit-dept ref="editDept" @refresh="refresh"></edit-dept>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getSysDeptList, createSysDept, editSysDept, deleteSysDept, dragSysDept } from '@/api/baseInfo.js'
import EditDept from './editDept.vue'

export default {
  name: 'OrgTree',
  components: {
    EditDept
  },
  data () {
    return {
      title: '',
      treeData: [],
      searchValue: '',
      dragSort: Number,
      expandedKeys: [],
      defaultSelectedKeys: ['0-0'],
      isAppend: false,
      firstLogin: true,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      pNode: {},
      type: '',
      chartData: {},
      userList: []
    }
  },
  created () {
    this.queryDeptData(true)
  },
  methods: {
    ...mapActions(['handleSelectedDept', 'handleDeptList']),
    // 新增组织
    createOrg (data) {
      this.$refs.editDept.setTitle('新建组织机构')
      this.$refs.editDept.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.editDept.setModel({ pNode: data })
      this.$refs.editDept.open(true)
    },
    editOrg (data) {
      this.$refs.editDept.setTitle('编辑组织机构')
      this.$refs.editDept.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editDept.setModel(data)
      this.$refs.editDept.open(true)
    },
    refresh () {
      this.$emit('reGetData')
      this.queryDeptData()
    },
    deleteOrg (id) {
      const query = {
        ids: id
      }

      deleteSysDept(query).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          this.queryDeptData(true)
          this.$emit('reGetData')
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    // 获取组织机构树数据
    async queryDeptData (refresh) {
      const query = {
        id: 0,
        paging: false,
        name: this.searchValue.trim()
      }

      const res = await getSysDeptList(query)

      // this.querySysDeptList()

      if (res.status === 0) {
        this.treeData = res.data
        // 默认第一条数据被选中

        if (refresh) {
          if (this.treeData.length > 0) {
            const selectedItem = this.treeData[0]

            if (selectedItem.pid === 0) {
              selectedItem.pName = '一级组织机构'
            }
            this.handleSelectedDept(selectedItem)
            // this.firstLogin = false
          }
        }
      } else {
        this.$message.error(res.info.message)
      }
    },
    // querySysDeptList () {
    //   // 部门列表
    //   getSysDeptList({ paging: false, id: 0 }).then(res => {
    //     const data = this.deleteChildren(res.data)
    //     this.handleDeptList(data)
    //   })
    // },
    deleteChildren (arr) {
      const childs = arr
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.deleteChildren(childs[i].children)
          } else {
            delete childs[i].children
          }
        }
      }
      return arr
    },
    // 递归查找
    searchOption (option, arr, type = 'delect') {
      for (let s = 0; s < arr.length; s++) {
        if (arr[s].key === option.key) {
          if (type === 'delect') {
            arr.splice(s, 1)
          }
          break
        } else if (arr[s].children && arr[s].children.length > 0) {
          // 递归条件
          this.searchOption(option, arr[s].children)
        } else {
          continue
        }
      }
    },
    // 选择一个字典
    select (data, info) {
      if (info.selectedNodes.length) {
        this.expandedKeys.push(data[0])
        this.expandedKeys = Array.from(new Set(this.expandedKeys))

        var selectedItem = info.selectedNodes[0].data.props
        if (selectedItem.pid === 0) {
          selectedItem.pName = '一级组织机构'
        }
        selectedItem.key = info.node.dataRef.key

        if (!this.isAppend) {
          this.handleSelectedDept(selectedItem)
          this.$emit('formNavTitle', '编辑字典')
        }
      } else {
        this.handleSelectedDept({})
      }
      this.isAppend = false
    },
    // 拖动的确认
    showConfirm (info) {
      const vm = this
      var realPos, query

      if (info.dragNode.dataRef.pid === info.node.dataRef.id && info.dropPosition === 0) {
        this.$message.warning('拖拽的节点已位于目标节点下')
        return
      }

      // const dropKey = info.node.eventKey
      // const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dragPos = info.dragNode.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      // const parentNode = info.dragNode.pos.split('-')[1]

      if (dragPos.length === dropPos.length && dragPos[dragPos.length - 2] === dropPos[dropPos.length - 2]) {
        if (dropPosition === -1) {
          realPos = Number(dropPos[dropPos.length - 1]) + 1
        } else {
          realPos = Number(dropPos[dropPos.length - 1]) + 2
        }
        if (Number(dragPos[dragPos.length - 1]) < Number(dropPos[dropPos.length - 1])) {
          realPos = realPos - 1
        }
      } else {
        if (dropPosition === -1) {
          realPos = info.dropPosition + 2
        } else {
          realPos = info.dropPosition + 1
        }
      }

      query = {
        id: info.dragNode.dataRef.id,
        pid: dropPosition === 0 ? info.node.dataRef.id : info.node.dataRef.pid,
        sort: realPos
      }

      let showTitle = ''
      if (dropPosition === 0) {
        const childPos = info.node.dataRef.children.length + 1
        query.sort = childPos

        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.pName}】并调整顺序为第【${childPos}】位吗?`
      } else {
        showTitle = `您确定修改【${info.dragNode.dataRef.name}】的父节点为【${info.node.dataRef.pName ||
          '一级菜单'}】并调整顺序为第【${query.sort}】位吗?`
      }

      this.$confirm({
        title: showTitle,
        onOk () {
          return new Promise((resolve, reject) => {
            setTimeout(resolve, 1000)
            vm.onDrop(info, query)
          }).catch(() => console.log('errors!'))
        },
        onCancel () {}
      })
    },
    // 开始拖拽
    onStart (info) {
      this.dragSort = info.node.dataRef.sort
    },
    // 字典拖拽
    async onDrop (info, query) {
      const res = await dragSysDept(query)

      if (res.status === 0) {
        this.$message.success('操作成功!')
        // 拖拽完后重新获取树信息(因为sort值已经改变)
        this.queryDeptData()
        // 重新获取selectbox的数据
        this.$emit('reGetData')
      } else {
        this.$message.error(res.info.message)
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
<style lang="less">
.ant-modal-body{
  #chart-container{
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  // .ant-tree-title {
  //   width: 100%;

  //   & > span {
  //     // width: 90px;
  //     display: inline-block;
  //     white-space: pre-line;
  //   }
  // }
  // .title {
  //   float: left;
  // }

  .ant-card-body {
    padding: 0;

    .ant-btn {
        margin-bottom: 12px;
      }

    // :global {
    //   .ant-tree {
    //     line-height: 3;

    //     .ant-tree-node-content-wrapper,
    //     .ant-tree-switcher {
    //       // margin-top: 7px;
    //     }
    //     .ant-tree-node-content-wrapper:hover {
    //       background: transparent;
    //     }
    //     .ant-tree-treenode-selected {
    //       background: #e6f7ff;
    //       .ant-tree-node-selected {
    //         background: transparent;
    //       }
    //     }

    //     .ant-tree-child-tree {
    //       background: #fff;
    //     }
    //     li {
    //       position: relative;
    //       line-height: 3;
    //       padding-bottom: 0;
    //     }
    //   }
    //   .ant-btn {
    //     margin-bottom: 8px;
    //   }
    // }

    // .icon-panel {
    //   // float: right;
    //   position: absolute;
    //   right: 10px;
    //   top: 13px;

    //   .anticon-plus,
    //   .anticon-setting,
    //   .anticon-edit,
    //   .anticon-delete {
    //     margin-left: 5px;
    //     color: #1890ff;
    //   }
    // }
  }
}
</style>
